import React, { Fragment } from "react";
import Navbar from "../../components/Navbar";
import Hero from "../../components/hero";
import About from "../../components/about";
import Features from "../../components/Features";
import WorkAreas from "../../components/WorkAreas";
import EventSection from "../../components/event";
import CtaSection from "../../components/cta";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import abimg from "../../images/juzour1.jpg";
import hero1 from "../../images/juzour-bg.jpg";
import Project1 from "../../components/project";
import abimg2 from "../../images/muhra1.jpg";

const HomePage = () => {
  return (
    <Fragment>
      <Navbar />
      <Hero Hero={hero1} />
      <About AbImg={abimg} />
      <Features />
      <WorkAreas />
      <EventSection />
      <CtaSection />
      <Project1 AbImg={abimg2} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage;
